import { ReactElement } from 'react';
import { styled } from 'styled-components';
import { Button } from 'antd';
import { SearchOutlined, CloseOutlined } from '@ant-design/icons';
import { blockStyle } from '../../../../../components/styles/Block';

const Block = styled.div`
  ${blockStyle}
  display: flex;
  gap: 16px;
  align-items: center;
`;

const SearchButton = styled(Button)`
  && {
    font-size: 12px;
    height: 28px;
    padding: 0 12px;
  }
`;

const ClearButton = styled(Button)<{ $isActive: boolean }>`
  color: #666;
  padding: 0;
  background: transparent;
  font-size: 12px;
`;

interface Props {
  isFormModified: boolean;
  onClear: () => void;
}

const ButtonRow = ({ isFormModified, onClear }: Props): ReactElement => (
  <Block>
    <SearchButton type='primary' htmlType='submit' icon={<SearchOutlined />}>
      検索
    </SearchButton>
    <ClearButton
      type='link'
      icon={<CloseOutlined />}
      onClick={onClear}
      disabled={!isFormModified}
      $isActive={isFormModified}
    >
      クリア
    </ClearButton>
  </Block>
);

export default ButtonRow;
